import React from "react";

export const Logo = ({ className = "", variant = "default" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src="https://customer-assets-wrfwihn1.emergentagent.net/job_elyon-aviation/artifacts/xytr82sl_El%20Elyon%20Air%20logo.jpg"
        alt="El Elyon Air"
        className="h-11 w-11 object-contain invert brightness-125 contrast-125"
        loading="lazy"
      />
      <div className="leading-none">
        <div className="font-display text-[13px] tracking-[0.24em] uppercase">
          El Elyon
        </div>
        <div className="font-serif-italic text-[11px] tracking-[0.2em] text-white/60 -mt-0.5">
          Air
        </div>
      </div>
    </div>
  );
};
